import { Controller } from '@hotwired/stimulus';
import Redactor from "../../assets/javascripts/admin/redactor/redactor.min";
import '../../assets/javascripts/admin/redactor/plugins';

export default class RedactorController extends Controller {
  connect () {
    this.initializeEditors();

    // Re-initialize on dynamically added content
    document.addEventListener('has_many_add:after', () => {
      this.initializeEditors();
    });
  }

  initializeEditors() {
    const csrfToken = document.querySelector('meta[name=csrf-token]')?.content;
    const csrfParam = document.querySelector('meta[name=csrf-param]')?.content;
    const csrf = csrfToken && csrfParam ? `${csrfParam}=${encodeURIComponent(csrfToken)}` : '';
    const imageUploadURL = `/redactor/image_upload?${csrf}`;

    this.element.querySelectorAll('.redactor').forEach((el) => {
      if (!el._redactorInitialized) {
        Redactor(el, {
          plugins: ["fontcolor", "fontsize", "alignment", "fullscreen", "table", "video", "googleMapsPlugin"],
          buttons: [
            "format", "redo", "undo", "fontcolor", "fontsize", "bold", "italic", "underline", "deleted",
            "lists", "table", "image", "link", "alignment", "html", "video", "googlemaps"
          ],
          formatting: ["p", "blockquote"],
          imageUpload: imageUploadURL,
          imagePosition: true,
          imageResizable: true,
          lang: "fr"
        });
        el._redactorInitialized = true;
      }
    });

    this.element.querySelectorAll('.redactor-banner').forEach((el) => {
      if (!el._redactorInitialized) {
        Redactor(el, {
          plugins: ["fontcolor", "fontsize", "alignment", "fullscreen", "table"],
          buttons: [
            "format", "redo", "undo", "fontcolor", "fontsize", "bold", "italic", "underline", "deleted",
            "lists", "table", "image", "link", "alignment"
          ],
          formatting: ["p", "blockquote"],
          imageUpload: imageUploadURL,
          imagePosition: true,
          imageResizable: true,
          lang: "fr"
        });
        el._redactorInitialized = true;
      }
    });
  }
}


